var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "dropdown-container",
      attrs: { id: "seachCategoriesDropdown" },
    },
    [
      _c("h1", [
        _vm._v(
          "\n    " +
            _vm._s(
              _vm.$translate("maversandVuePlugin::Additional.deviceManagerHead")
            ) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    " +
            _vm._s(
              _vm.$translate("maversandVuePlugin::Additional.deviceManagerSub")
            ) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("div", { staticClass: "row", attrs: { "selection-section": "" } }, [
        _c("div", { staticClass: "col" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.deviceName,
                expression: "deviceName",
              },
            ],
            attrs: { type: "text", placeholder: "Gerätename eingeben..." },
            domProps: { value: _vm.deviceName },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.deviceName = $event.target.value
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col" }, [
          _c(
            "div",
            {
              staticClass: "dropdown",
              class: { open: _vm.showDropdown.device },
              on: {
                click: function ($event) {
                  return _vm.toggleDropdown("device")
                },
              },
            },
            [
              _c("div", { staticClass: "dropdown-selected" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.selectedDevice
                        ? _vm.selectedDevice.lang.de.name
                        : "Produktkategorie wählen"
                    ) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("transition", { attrs: { name: "slide-fade" } }, [
                _vm.showDropdownComp.device
                  ? _c(
                      "div",
                      { staticClass: "dropdown-options" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.deviceSearch,
                              expression: "deviceSearch",
                            },
                          ],
                          attrs: {
                            type: "text",
                            placeholder: "Produkt suchen...",
                          },
                          domProps: { value: _vm.deviceSearch },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                            },
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.deviceSearch = $event.target.value
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.filteredDevices, function (device) {
                          return _c(
                            "div",
                            {
                              key: device.id,
                              staticClass: "dropdown-option",
                              on: {
                                click: function ($event) {
                                  return _vm.selectDevice(device)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(device.lang.de.name) +
                                  "\n            "
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    )
                  : _vm._e(),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dropdown",
              class: {
                open: _vm.showDropdown.hersteller,
                disabled: !_vm.selectedDevice,
              },
              on: {
                click: function ($event) {
                  return _vm.toggleDropdown("hersteller")
                },
              },
            },
            [
              _c("div", { staticClass: "dropdown-selected" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.selectedHersteller
                        ? _vm.selectedHersteller.lang.de.name
                        : "Hersteller wählen"
                    ) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("transition", { attrs: { name: "slide-fade" } }, [
                _vm.showDropdownComp.hersteller
                  ? _c(
                      "div",
                      { staticClass: "dropdown-options" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.herstellerSearch,
                              expression: "herstellerSearch",
                            },
                          ],
                          attrs: {
                            type: "text",
                            placeholder: "Hersteller suchen...",
                          },
                          domProps: { value: _vm.herstellerSearch },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                            },
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.herstellerSearch = $event.target.value
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.filteredHerstellers, function (hersteller) {
                          return _c(
                            "div",
                            {
                              key: hersteller.id,
                              staticClass: "dropdown-option",
                              on: {
                                click: function ($event) {
                                  return _vm.selectHersteller(hersteller)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(hersteller.lang.de.name) +
                                  "\n            "
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    )
                  : _vm._e(),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dropdown",
              class: {
                open: _vm.showDropdown.model,
                disabled: !_vm.selectedHersteller,
              },
              on: {
                click: function ($event) {
                  return _vm.toggleDropdown("model")
                },
              },
            },
            [
              _c("div", { staticClass: "dropdown-selected" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.selectedModel
                        ? _vm.selectedModel.lang.de.name
                        : "Modell wählen"
                    ) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("transition", { attrs: { name: "slide-fade" } }, [
                _vm.showDropdownComp.model && _vm.selectedModel === null
                  ? _c(
                      "div",
                      { staticClass: "dropdown-options" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.modelSearch,
                              expression: "modelSearch",
                            },
                          ],
                          attrs: {
                            type: "text",
                            placeholder: "Models suchen...",
                          },
                          domProps: { value: _vm.modelSearch },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                            },
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.modelSearch = $event.target.value
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.filteredModels, function (model) {
                          return _c(
                            "div",
                            {
                              key: model.id,
                              staticClass: "dropdown-option",
                              on: {
                                click: function ($event) {
                                  return _vm.selectModel(model)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(model.lang.de.name) +
                                  "\n            "
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    )
                  : _vm._e(),
              ]),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-lg btn-primary",
          attrs: { disabled: !_vm.selectedModel },
          on: { click: _vm.saveDevice },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.$translate(
                  "maversandVuePlugin::Additional.deviceManagerCreateNewDeviceButton"
                )
              ) +
              "\n  "
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }